import React from "react";
import loadable from "../utils/loadable";
import Loading from "./Loading";

// Loading - No need to lazy load this component
export { default as Loading } from "./Loading";

export const Welcome = loadable(() => import("./Welcome"), {
  fallback: <Loading />,
});
export const Navbar = loadable(() => import("./layout/Navbar"), {
  fallback: <Loading />,
});
export const Footer = loadable(() => import("./layout/Footer"), {
  fallback: <Loading />,
});
export const TopAnimation = loadable(() => import("./Home/TopAnimation"), {
  fallback: <Loading />,
});
export const RoadmapSlider = loadable(() => import("./RoadmapSlider"), {
  fallback: <Loading />,
});
export const ImageText = loadable(() => import("./Solution/ImageText"), {
  fallback: <Loading />,
});
export const RightSidebarDrawer = loadable(
  () => import("./RightSidebarDrawer"),
  {
    fallback: <Loading />,
  },
);
export const BlogCard = loadable(() => import("./BlogCard"), {
  fallback: <Loading />,
});
export const DisplayTweets = loadable(() => import("./DisplayTweets"), {
  fallback: <Loading />,
});

export const BlogCardSlider = loadable(() => import("./BlogCardSlider"), {
  fallback: <Loading />,
});

// Hero Section Home
export const HeroSection = loadable(() => import("./Home/HeroSection"), {
  fallback: <Loading />,
});
export const Partners = loadable(() => import("./Home/Partners"), {
  fallback: <Loading />,
});
export const PartnersPage = loadable(() => import("./Home/PartnersPage"), {
  fallback: <Loading />,
});
export const CentralizedExchange = loadable(
  () => import("./Home/CentralizedExchange"),
  {
    fallback: <Loading />,
  },
);
// New Header
export const Header = loadable(() => import("./layout/Header"), {
  fallback: <Loading />,
});
// Redefine Future Section
export const RedefineFuture = loadable(() => import("./Home/RedefineFuture"), {
  fallback: <Loading />,
});
// Transactions Section
export const Transactions = loadable(() => import("./Home/Transactions"), {
  fallback: <Loading />,
});

export const HeroSectionCommunity = loadable(
  () => import("./Community/HeroSection"),
  {
    fallback: <Loading />,
  },
);

export const WhyPartOf = loadable(() => import("./Community/WhyPartOf"), {
  fallback: <Loading />,
});

export const WaysYouCan = loadable(() => import("./Community/WaysYouCan"), {
  fallback: <Loading />,
});

export const BuildsTogether = loadable(
  () => import("./Community/BuildsTogether"),
  {
    fallback: <Loading />,
  },
);

export const WhatYouFind = loadable(() => import("./Community/WhatYouFind"), {
  fallback: <Loading />,
});

export const OpportunitiesSection = loadable(
  () => import("./Community/OpportunitiesSection"),
  {
    fallback: <Loading />,
  },
);

export const TeamAndPartnersHeroSection = loadable(
  () => import("./TeamAndPartners/HeroSection"),
  {
    fallback: <Loading />,
  },
);

export const FoundingMembers = loadable(
  () => import("./TeamAndPartners/FoundingMembers"),
  {
    fallback: <Loading />,
  },
);

export const TeamExpertise = loadable(
  () => import("./TeamAndPartners/TeamExpertise"),
  {
    fallback: <Loading />,
  },
);

export const LegalAdvisors = loadable(
  () => import("./TeamAndPartners/LegalAdvisors"),
  {
    fallback: <Loading />,
  },
);

export const PartnersSection = loadable(
  () => import("./TeamAndPartners/PartnersSection"),
  {
    fallback: <Loading />,
  },
);

export const NotificationComponent = loadable(
  () => import("./NotificationComponent"),
  {
    fallback: <Loading />,
  },
);

export const YouTubeLinkModal = loadable(
  () => import("./modals/YouTubeLinkModal"),
  {
    fallback: <Loading />,
  },
);

export const ClubCommission = loadable(
  () => import("./modals/ClubCommission"),
  {
    fallback: <Loading />,
  },
);

export const TrackPageView = loadable(() => import("./TrackPageView"), {
  fallback: <Loading />,
});

export const Notifications = loadable(() => import("./Notifications"), {
  fallback: <Loading />,
});

export const DynamicTitle = loadable(() => import("./DynamicTitle"), {
  fallback: <Loading />,
});

export const UserProfile = loadable(() => import("./Profile"), {
  fallback: <Loading />,
});

export const PerspectiveGrid = loadable(() => import("./Perspective"), {
  fallback: <Loading />,
});

export const Ambassdor = loadable(() => import("./Ambassador"), {
  fallback: <Loading />,
});

export const Cancellation = loadable(() => import("./Cancellation"), {
  fallback: <Loading />,
});

export const DashboardCards = loadable(() => import("./DashboardCards"), {
  fallback: <Loading />,
});

export const LinkedinTracker = loadable(() => import("./LinkedinTracker"), {
  fallback: <Loading />,
});

export const MstBuddy = loadable(() => import("./Home/MstBuddy"), {
  fallback: <Loading />,
});
